"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _Container = _interopRequireDefault(require("../common/Container"));
var _Coverages = _interopRequireDefault(require("./Coverages"));
var _Codacy = _interopRequireDefault(require("./Codacy"));
var _jsxRuntime = require("react/jsx-runtime");
var Coverage = function Coverage(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Container["default"], (0, _objectSpread2["default"])({}, props));
};
Coverage.Coverages = _Coverages["default"];
Coverage.Codacy = _Codacy["default"];
Coverage.displayName = 'Github';
var _default = exports["default"] = Coverage;
module.exports = exports.default;